/* MCR · AI-Vision product gallery
   Enhances Dawn's <media-gallery> without replacing it:
   counter + mobile dots, AI scan / viewfinder / insight hotspots, detail focus (Ken Burns), hover lens,
   full-screen lightbox (swipe, pinch, double-tap zoom, crossfade) and colour filtering by image alt text.
   Vanilla JS, no dependencies, reduced-motion aware. */
(function () {
  'use strict';
  if (window.MCRGallery) return;

  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) doc.documentElement.classList.add('mcr-reduce');
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktop = window.matchMedia && window.matchMedia('(min-width: 990px)');

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function icon(path) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + path + '</svg>';
  }
  var ICON_CLOSE = icon('<path d="M6 6l12 12M18 6 6 18"/>');
  var ICON_ARROW = icon('<path d="M5 12h14M13 6l6 6-6 6"/>');

  /* ================= Lightbox ================= */
  function Lightbox(gallery) {
    this.g = gallery;
    this.el = null;
    this.index = 0;
    this.items = [];
    this.state = [];
    this.pointers = new Map();
    this.lastTap = 0;
  }

  Lightbox.prototype.build = function () {
    var ds = this.g.el.dataset;
    var el = doc.createElement('div');
    el.className = 'mcr-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', doc.title);
    el.innerHTML =
      '<div class="mcr-lightbox__top">' +
      '<span class="mcr-lightbox__count" aria-live="polite"></span>' +
      (ds.labelBadge ? '<span class="mcr-ai-badge">' + icon('<path d="M12 3c.6 4.2 2.8 6.4 7 7-4.2.6-6.4 2.8-7 7-.6-4.2-2.8-6.4-7-7 4.2-.6 6.4-2.8 7-7Z"/>') + '<span></span></span>' : '') +
      '<button type="button" class="mcr-lightbox__close">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="mcr-lightbox__stage"></div>' +
      '<button type="button" class="mcr-lightbox__nav mcr-lightbox__nav--prev">' + ICON_ARROW + '</button>' +
      '<button type="button" class="mcr-lightbox__nav mcr-lightbox__nav--next">' + ICON_ARROW + '</button>' +
      '<p class="mcr-lightbox__hint"></p>' +
      '<div class="mcr-lightbox__thumbs" role="list"></div>';
    var badgeText = el.querySelector('.mcr-ai-badge span');
    if (badgeText) badgeText.textContent = ds.labelBadge;
    el.querySelector('.mcr-lightbox__close').setAttribute('aria-label', ds.labelClose || 'Close');
    el.querySelector('.mcr-lightbox__nav--prev').setAttribute('aria-label', ds.labelPrev || 'Previous');
    el.querySelector('.mcr-lightbox__nav--next').setAttribute('aria-label', ds.labelNext || 'Next');
    var hint = el.querySelector('.mcr-lightbox__hint');
    if (ds.labelHint) hint.textContent = ds.labelHint;
    else hint.remove();
    doc.body.appendChild(el);
    this.el = el;
    this.stage = el.querySelector('.mcr-lightbox__stage');
    this.thumbs = el.querySelector('.mcr-lightbox__thumbs');
    this.count = el.querySelector('.mcr-lightbox__count');

    var self = this;
    el.querySelector('.mcr-lightbox__close').addEventListener('click', function () { self.close(); });
    el.querySelector('.mcr-lightbox__nav--prev').addEventListener('click', function () { self.go(self.index - 1); });
    el.querySelector('.mcr-lightbox__nav--next').addEventListener('click', function () { self.go(self.index + 1); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); self.close(); }
      else if (e.key === 'ArrowRight') self.go(self.index + 1);
      else if (e.key === 'ArrowLeft') self.go(self.index - 1);
      else if (e.key === 'Tab') self.trap(e);
    });
    this.stage.addEventListener('pointerdown', this.onDown.bind(this));
    this.stage.addEventListener('pointermove', this.onMove.bind(this));
    this.stage.addEventListener('pointerup', this.onUp.bind(this));
    this.stage.addEventListener('pointercancel', this.onUp.bind(this));
    this.stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  Lightbox.prototype.trap = function (e) {
    var f = this.el.querySelectorAll('button:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Lightbox.prototype.populate = function (items) {
    this.items = items;
    this.state = items.map(function () { return { s: 1, x: 0, y: 0 }; });
    this.stage.innerHTML = '';
    this.thumbs.innerHTML = '';
    var self = this;
    var dotLabel = this.g.el.dataset.labelDot || '';
    items.forEach(function (it, i) {
      var fig = doc.createElement('figure');
      fig.className = 'mcr-lightbox__slide';
      var img = doc.createElement('img');
      img.alt = it.alt || '';
      img.decoding = 'async';
      img.draggable = false;
      img.sizes = '100vw';
      img.dataset.srcset = it.srcset;
      fig.appendChild(img);
      self.stage.appendChild(fig);

      var t = doc.createElement('button');
      t.type = 'button';
      t.className = 'mcr-lightbox__thumb';
      t.setAttribute('role', 'listitem');
      t.setAttribute('aria-label', dotLabel.replace('[n]', i + 1));
      if (it.thumb) {
        var ti = doc.createElement('img');
        ti.src = it.thumb;
        ti.alt = '';
        ti.loading = 'lazy';
        ti.width = 104;
        ti.height = 104;
        t.appendChild(ti);
      }
      t.addEventListener('click', function () { self.go(i); });
      self.thumbs.appendChild(t);
    });
    if (items.length < 2) {
      this.el.querySelectorAll('.mcr-lightbox__nav').forEach(function (b) { b.hidden = true; });
      this.thumbs.hidden = true;
    } else {
      this.el.querySelectorAll('.mcr-lightbox__nav').forEach(function (b) { b.hidden = false; });
      this.thumbs.hidden = false;
    }
  };

  Lightbox.prototype.load = function (i) {
    var fig = this.stage.children[i];
    if (!fig) return;
    var img = fig.querySelector('img');
    if (img && !img.srcset && img.dataset.srcset) img.srcset = img.dataset.srcset;
  };

  Lightbox.prototype.open = function (items, start) {
    if (!this.el) this.build();
    this.populate(items);
    this.lastFocus = doc.activeElement;
    this.go(start, true);
    this.el.classList.add('is-open');
    doc.documentElement.classList.add('mcr-lock');
    var close = this.el.querySelector('.mcr-lightbox__close');
    setTimeout(function () { close.focus(); }, 50);
  };

  Lightbox.prototype.close = function () {
    if (!this.el) return;
    this.el.classList.remove('is-open');
    if (!doc.querySelector('.mcr-modal.is-open')) doc.documentElement.classList.remove('mcr-lock');
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Lightbox.prototype.go = function (i, instant) {
    var n = this.items.length;
    if (!n) return;
    i = (i + n) % n;
    var prev = this.stage.children[this.index];
    if (prev && prev !== this.stage.children[i]) {
      this.state[this.index] = { s: 1, x: 0, y: 0 };
      this.apply(this.index, false);
    }
    this.index = i;
    this.load(i);
    this.load((i + 1) % n);
    this.load((i - 1 + n) % n);
    Array.prototype.forEach.call(this.stage.children, function (c, k) {
      c.classList.toggle('is-active', k === i);
      c.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    });
    Array.prototype.forEach.call(this.thumbs.children, function (t, k) {
      t.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    var active = this.thumbs.children[i];
    if (active && active.scrollIntoView && !instant) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
    this.count.textContent = pad(i + 1) + ' / ' + pad(n);
  };

  Lightbox.prototype.img = function () {
    var fig = this.stage.children[this.index];
    return fig ? fig.querySelector('img') : null;
  };

  Lightbox.prototype.apply = function (i, animate) {
    var fig = this.stage.children[i];
    if (!fig) return;
    var img = fig.querySelector('img');
    var st = this.state[i];
    img.classList.toggle('is-animating', !!animate && !reduce);
    img.style.transform = 'translate3d(' + st.x + 'px,' + st.y + 'px,0) scale(' + st.s + ')';
    fig.classList.toggle('is-zoomed', st.s > 1.01);
  };

  Lightbox.prototype.bounds = function (st) {
    var img = this.img();
    if (!img) return st;
    var w = img.offsetWidth, h = img.offsetHeight;
    if (st.s <= 1) return { s: 1, x: st.x, y: 0 };
    return { s: st.s, x: clamp(st.x, w - w * st.s, 0), y: clamp(st.y, h - h * st.s, 0) };
  };

  Lightbox.prototype.local = function (cx, cy) {
    var img = this.img();
    var fig = img.parentNode.getBoundingClientRect();
    return { x: cx - (fig.left + img.offsetLeft), y: cy - (fig.top + img.offsetTop) };
  };

  Lightbox.prototype.zoomAt = function (cx, cy, target) {
    var st = this.state[this.index];
    if (st.s > 1.01) {
      this.state[this.index] = { s: 1, x: 0, y: 0 };
    } else {
      var p = this.local(cx, cy);
      var s = target || 2.5;
      this.state[this.index] = this.bounds({ s: s, x: p.x - s * p.x, y: p.y - s * p.y });
    }
    this.apply(this.index, true);
  };

  Lightbox.prototype.onDown = function (e) {
    this.bgDown = false;
    if (!this.img() || e.target.tagName !== 'IMG') {
      if (e.target === this.stage || e.target.classList.contains('mcr-lightbox__slide')) this.bgDown = true;
    }
    try { this.stage.setPointerCapture(e.pointerId); } catch (err) {}
    this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    var st = this.state[this.index];
    this.start = { x: e.clientX, y: e.clientY, st: { s: st.s, x: st.x, y: st.y }, t: Date.now() };
    this.moved = false;
    if (this.pointers.size === 2) {
      var pts = Array.from(this.pointers.values());
      var mid = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
      var p = this.local(mid.x, mid.y);
      this.pinch = {
        d: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
        s: st.s,
        p: { x: (p.x - st.x) / st.s, y: (p.y - st.y) / st.s },
      };
    }
    var fig = this.stage.children[this.index];
    if (fig) fig.classList.add('is-dragging');
  };

  Lightbox.prototype.onMove = function (e) {
    if (!this.pointers.has(e.pointerId)) return;
    this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    var i = this.index;
    if (this.pointers.size === 2 && this.pinch) {
      var pts = Array.from(this.pointers.values());
      var d = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
      var s = clamp(this.pinch.s * (d / this.pinch.d), 1, 4);
      var mid = this.local((pts[0].x + pts[1].x) / 2, (pts[0].y + pts[1].y) / 2);
      this.state[i] = this.bounds({ s: s, x: mid.x - s * this.pinch.p.x, y: mid.y - s * this.pinch.p.y });
      this.moved = true;
      this.apply(i, false);
      return;
    }
    if (!this.start || this.pointers.size !== 1) return;
    var dx = e.clientX - this.start.x, dy = e.clientY - this.start.y;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) this.moved = true;
    var st0 = this.start.st;
    if (st0.s > 1.01) {
      this.state[i] = this.bounds({ s: st0.s, x: st0.x + dx, y: st0.y + dy });
    } else {
      this.state[i] = { s: 1, x: dx, y: 0 };
    }
    this.apply(i, false);
  };

  Lightbox.prototype.onUp = function (e) {
    if (!this.pointers.has(e.pointerId)) return;
    this.pointers.delete(e.pointerId);
    var fig = this.stage.children[this.index];
    if (this.pointers.size > 0) { this.pinch = null; return; }
    if (fig) fig.classList.remove('is-dragging');
    this.pinch = null;
    var i = this.index;
    var st = this.state[i];
    var start = this.start || { x: e.clientX, y: e.clientY, st: st };
    var dx = e.clientX - start.x;

    if (!this.moved) {
      if (this.bgDown) { this.bgDown = false; if (st.s <= 1.01) { this.close(); return; } }
      var now = Date.now();
      if (e.pointerType === 'mouse') {
        this.zoomAt(e.clientX, e.clientY);
      } else if (now - this.lastTap < 320) {
        this.zoomAt(e.clientX, e.clientY);
        this.lastTap = 0;
      } else {
        this.lastTap = now;
      }
      return;
    }
    this.bgDown = false;
    if (start.st.s <= 1.01 && st.s <= 1.01) {
      if (Math.abs(dx) > 60 && this.items.length > 1) {
        this.state[i] = { s: 1, x: 0, y: 0 };
        this.apply(i, false);
        this.go(dx < 0 ? i + 1 : i - 1);
      } else {
        this.state[i] = { s: 1, x: 0, y: 0 };
        this.apply(i, true);
      }
    } else if (st.s < 1.05) {
      this.state[i] = { s: 1, x: 0, y: 0 };
      this.apply(i, true);
    }
  };

  /* ================= Gallery ================= */
  function Gallery(el) {
    this.el = el;
    this.sectionId = (el.id || '').replace('MediaGallery-', '');
    this.list = el.querySelector('[id^="Slider-Gallery"]');
    this.hud = el.querySelector('[data-mcr-hud]');
    this.dots = el.querySelector('[data-mcr-dots]');
    this.current = 0;
    this.ratios = new Map();
    if (!this.list) return;
    this.setupObservers();
    this.setupTools();
    this.setupLens();
    this.setupZoom();
    this.setupFilter();
    this.refresh();
  }

  Gallery.prototype.items = function () {
    return Array.prototype.filter.call(this.list.children, function (li) {
      return li.hasAttribute('data-media-id') && !li.classList.contains('is-mcr-filtered');
    });
  };

  Gallery.prototype.setupObservers = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { self.ratios.set(en.target, en.isIntersecting ? en.intersectionRatio : 0); });
      var best = null, bestR = 0;
      self.ratios.forEach(function (r, li) { if (r > bestR && li.isConnected) { bestR = r; best = li; } });
      if (best) {
        var idx = self.items().indexOf(best);
        if (idx > -1) self.setCurrent(idx);
      }
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

    this.vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || en.intersectionRatio < 0.3) return;
        var li = en.target;
        self.vio.unobserve(li);
        li.classList.add('is-vision-in');
        if (!reduce && doc.documentElement.classList.contains('mcr-anim')) {
          li.classList.add('is-vision-scan');
          setTimeout(function () { li.classList.remove('is-vision-scan'); }, 1900);
        }
      });
    }, { threshold: [0.3, 0.6] });
  };

  Gallery.prototype.refresh = function () {
    var self = this;
    var items = this.items();
    Array.prototype.forEach.call(this.list.children, function (li) {
      if (!li.hasAttribute('data-media-id')) return;
      if (self.io && !li.__mcrObserved) {
        li.__mcrObserved = true;
        self.io.observe(li);
        if (li.querySelector('.mcr-vision')) self.vio.observe(li);
      }
      if (!self.vio && li.querySelector('.mcr-vision')) li.classList.add('is-vision-in');
    });
    var total = this.el.querySelector('[data-mcr-total]');
    if (total) total.textContent = pad(items.length);
    var counter = this.el.querySelector('.mcr-gallery__counter');
    if (counter) counter.hidden = items.length < 2;
    this.buildDots(items);
    if (this.current >= items.length) this.current = 0;
    this.setCurrent(this.current, true);
    var toggle = this.el.querySelector('[data-mcr-insights-toggle]');
    if (toggle) toggle.hidden = !this.list.querySelector('[data-mcr-insights]');
  };

  Gallery.prototype.buildDots = function (items) {
    if (!this.dots) return;
    var self = this;
    var label = this.el.dataset.labelDot || '';
    this.dots.innerHTML = '';
    if (items.length < 2) return;
    items.forEach(function (li, i) {
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'mcr-gallery__dot';
      b.setAttribute('aria-label', label.replace('[n]', i + 1));
      b.addEventListener('click', function () {
        self.list.scrollTo({ left: li.offsetLeft - self.list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
      self.dots.appendChild(b);
    });
  };

  Gallery.prototype.setCurrent = function (i, force) {
    if (i === this.current && !force) return;
    this.current = i;
    var cur = this.el.querySelector('[data-mcr-current]');
    if (cur) cur.textContent = pad(i + 1);
    if (this.dots) {
      Array.prototype.forEach.call(this.dots.children, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
  };

  Gallery.prototype.setupTools = function () {
    var self = this;
    var toggle = this.el.querySelector('[data-mcr-insights-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var on = toggle.getAttribute('aria-pressed') !== 'true';
        toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
        self.el.querySelectorAll('[data-mcr-insights]').forEach(function (n) { n.classList.toggle('is-hidden', !on); });
      });
    }
    var focus = this.el.querySelector('[data-mcr-detail-focus]');
    if (focus) {
      focus.addEventListener('click', function () {
        var items = self.items();
        var li = items[self.current];
        if (!li || !li.hasAttribute('data-mcr-zoom')) li = items.filter(function (x) { return x.hasAttribute('data-mcr-zoom'); })[0];
        if (!li) return;
        var cls = reduce ? 'is-detail-static' : 'is-detail-focus';
        var active = li.classList.contains(cls);
        self.el.querySelectorAll('.is-detail-focus, .is-detail-static').forEach(function (n) { n.classList.remove('is-detail-focus', 'is-detail-static'); });
        focus.setAttribute('aria-pressed', 'false');
        if (active) return;
        li.classList.add(cls);
        focus.setAttribute('aria-pressed', 'true');
        if (!reduce) {
          var img = li.querySelector('.product__media img');
          if (img) {
            img.addEventListener('animationend', function done() {
              img.removeEventListener('animationend', done);
              li.classList.remove('is-detail-focus');
              focus.setAttribute('aria-pressed', 'false');
            });
          }
        }
      });
    }
  };

  /* ---------- hover lens ---------- */
  Gallery.prototype.setupLens = function () {
    if (this.el.dataset.zoomMode !== 'mcr' || !canHover) return;
    var self = this;
    var z = parseFloat(this.el.dataset.lens) || 2.5;
    var lens = null, host = null, img = null, frame = 0, last = null;

    function srcFor(li) {
      var set = (li.getAttribute('data-mcr-zoom') || '').split(',');
      var pick = set[1] || set[0] || '';
      return pick.trim().split(' ')[0];
    }
    function hide() {
      if (lens) lens.classList.remove('is-on');
      host = null;
    }
    function move() {
      frame = 0;
      if (!host || !last || !img) return;
      var r = img.getBoundingClientRect();
      var hr = host.getBoundingClientRect();
      var x = last.clientX - r.left, y = last.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) { lens.classList.remove('is-on'); return; }
      var lw = lens.offsetWidth, lh = lens.offsetHeight;
      lens.style.backgroundSize = r.width * z + 'px ' + r.height * z + 'px';
      lens.style.backgroundPosition = -(x * z - lw / 2) + 'px ' + -(y * z - lh / 2) + 'px';
      lens.style.transform = 'translate3d(' + (last.clientX - hr.left - lw / 2) + 'px,' + (last.clientY - hr.top - lh / 2) + 'px,0)';
      lens.classList.add('is-on');
    }
    this.list.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !desktop.matches || !canHover.matches) return;
      var li = e.target.closest && e.target.closest('li[data-mcr-zoom]');
      if (!li || li.classList.contains('is-detail-focus') || li.classList.contains('is-detail-static')) { hide(); return; }
      var h = li.querySelector('.product-media-container');
      if (!h) return;
      if (h !== host) {
        host = h;
        img = h.querySelector('.product__media img');
        if (!lens) {
          lens = doc.createElement('div');
          lens.className = 'mcr-lens';
          lens.setAttribute('aria-hidden', 'true');
        }
        h.appendChild(lens);
        lens.style.backgroundImage = 'url("' + srcFor(li) + '")';
      }
      last = e;
      if (!frame) frame = requestAnimationFrame(move);
    }, { passive: true });
    this.list.addEventListener('pointerleave', hide, { passive: true });
  };

  /* ---------- lightbox trigger ---------- */
  Gallery.prototype.setupZoom = function () {
    if (this.el.dataset.zoomMode !== 'mcr') return;
    var self = this;
    this.lightbox = new Lightbox(this);
    this.list.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-mcr-zoom-open]');
      if (!btn) return;
      e.preventDefault();
      var li = btn.closest('li[data-media-id]');
      var images = self.items().filter(function (x) { return x.hasAttribute('data-mcr-zoom'); });
      var data = images.map(function (x) {
        var im = x.querySelector('.product__media img');
        return {
          srcset: x.getAttribute('data-mcr-zoom'),
          alt: im ? im.alt : '',
          thumb: im ? im.currentSrc || im.src : '',
        };
      });
      var start = Math.max(0, images.indexOf(li));
      self.lightbox.open(data, start);
    });
  };

  /* ---------- colour filter via alt text ---------- */
  Gallery.prototype.setupFilter = function () {
    if (this.el.dataset.filterAlt !== 'true') return;
    try { this.options = JSON.parse(this.el.dataset.productOptions || '[]'); } catch (e) { this.options = []; }
    this.names = (this.el.dataset.filterOptions || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var vs = doc.getElementById('variant-selects-' + this.sectionId);
    var script = vs && vs.querySelector('[data-selected-variant]');
    if (script) {
      try { this.filter(JSON.parse(script.textContent)); } catch (e) {}
    }
  };

  Gallery.prototype.filter = function (variant) {
    if (!variant || !variant.options || !this.names) return;
    var idx = -1;
    var names = this.names;
    this.options.forEach(function (o, i) { if (names.indexOf(String(o).toLowerCase()) > -1) idx = i; });
    if (idx < 0) return;
    var value = String(variant.options[idx] || '').toLowerCase().trim();
    if (!value) return;
    var all = Array.prototype.filter.call(this.list.children, function (li) { return li.hasAttribute('data-media-id'); });
    var matches = all.filter(function (li) { return li.hasAttribute('data-mcr-zoom') && (li.getAttribute('data-mcr-alt') || '').indexOf(value) > -1; });
    var matchIds = matches.map(function (li) { return li.getAttribute('data-media-id'); });
    var on = matches.length > 0;
    all.forEach(function (li) {
      var hide = on && li.hasAttribute('data-mcr-zoom') && matchIds.indexOf(li.getAttribute('data-media-id')) === -1;
      li.classList.toggle('is-mcr-filtered', hide);
    });
    this.el.querySelectorAll('[data-target]').forEach(function (t) {
      var alt = t.getAttribute('data-mcr-alt') || '';
      var isImg = !t.querySelector('.thumbnail__badge');
      t.classList.toggle('is-mcr-filtered', on && isImg && matchIds.indexOf(t.getAttribute('data-target')) === -1 && alt.indexOf(value) === -1);
    });
    var active = this.list.querySelector('.is-active');
    if (on && active && active.classList.contains('is-mcr-filtered') && typeof this.el.setActiveMedia === 'function') {
      this.el.setActiveMedia(matches[0].getAttribute('data-media-id'), false);
    }
    this.current = 0;
    this.refresh();
  };

  /* ---------- colour without its own linked photo: bring the photo named after it to the front ---------- */
  Gallery.prototype.promote = function (variant) {
    if (!variant || variant.featured_media || !variant.options || !this.list) return;
    var opts = this.options;
    if (!opts) { try { opts = JSON.parse(this.el.dataset.productOptions || '[]'); } catch (e) { opts = []; } }
    var idx = -1;
    opts.forEach(function (o, i) { if (/colou?r|shade/i.test(String(o))) idx = i; });
    this.promoteValues(idx > -1 ? [variant.options[idx]] : variant.options);
  };
  // Bring the first photo whose alt text or file name contains one of these words to the front.
  Gallery.prototype.promoteValues = function (list) {
    if (!this.list) return;
    var values = (list || [])
      .map(function (v) { return String(v || '').toLowerCase().replace(/[_-]+/g, ' ').trim(); })
      .filter(function (v) { return v.length > 2 && !/^\d/.test(v); });
    if (!values.length) return;
    var norm = function (t) { return ' ' + String(t || '').toLowerCase().replace(/[_.-]+/g, ' ') + ' '; };
    var items = Array.prototype.filter.call(this.list.children, function (li) { return li.hasAttribute('data-media-id'); });
    var hit = null;
    items.some(function (li) {
      var img = li.querySelector('img');
      var file = img ? (img.getAttribute('src') || '').split('/').pop().split('?')[0] : '';
      var hay = norm(li.getAttribute('data-mcr-alt')) + norm(img && img.getAttribute('alt')) + norm(file);
      if (values.some(function (v) { return hay.indexOf(' ' + v + ' ') > -1; })) { hit = li; return true; }
      return false;
    });
    if (!hit || hit === items[0] || typeof this.el.setActiveMedia !== 'function') return;
    this.el.setActiveMedia(hit.getAttribute('data-media-id'), true);
    this.current = 0;
    this.refresh();
  };

  /* ================= boot ================= */
  var instances = [];
  function init(scope) {
    (scope || doc).querySelectorAll('[data-mcr-gallery]').forEach(function (el) {
      if (el.__mcrGallery || el.closest('quick-add-modal')) return;
      el.__mcrGallery = new Gallery(el);
      instances.push(el.__mcrGallery);
    });
  }

  function onVariant(payload) {
    var data = payload && payload.data;
    if (!data) return;
    init(doc);
    instances.forEach(function (g) {
      if (!g.el.isConnected || !g.list) return;
      if (data.sectionId && g.sectionId !== data.sectionId) return;
      if (g.names) g.filter(data.variant);
      else g.refresh();
      g.promote(data.variant);
    });
  }

  function boot() {
    init(doc);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, onVariant);
  }
  window.MCRGallery = { init: init };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
